import { updateEmojiFrequency } from '~publish/helpers/emojiFrequency'
import type { BufferEditor } from '~publish/legacy/editor/BufferEditor/types.plate'
import { EmojiElement } from '../nodes'
import type { EmojiPluginOptions, EmojiSearchData } from '../types'

const isEmojiPlugin = (
  plugin: unknown,
): plugin is { options: EmojiPluginOptions } =>
  typeof plugin === 'object' &&
  plugin !== null &&
  'options' in plugin &&
  typeof plugin.options === 'object' &&
  plugin.options !== null

// InlineCombobox.Item's onSelect fires after the trigger node is already
// removed (InlineCombobox's own select() calls removeInput() first, then
// this callback) — the editor's selection is left collapsed where that node
// was, so this inserts at the current selection rather than looking the
// (now-gone) search node back up by path.
export const createEmojiOnSelectItem =
  (key = EmojiElement.type) =>
  (editor: BufferEditor, emoji: EmojiSearchData): void => {
    const plugin = editor.meta.pluginList.find(
      (candidate) => candidate.key === key,
    )
    if (!isEmojiPlugin(plugin)) return
    const { insertSpaceAfterEmoji } = plugin.options

    const nativeEmoji = emoji.skins[0]?.native
    if (!nativeEmoji) return

    updateEmojiFrequency(nativeEmoji)

    editor.tf.insertText(nativeEmoji)

    if (insertSpaceAfterEmoji) {
      editor.tf.insertText(' ')
    }
  }
